/* global axios */

/**
 * Aceleres -- "Número da Equipe".
 *
 * Marcação/desmarcação do contato, histórico de movimentações e listagem
 * administrativa. A autorização é sempre validada no backend.
 */

const accountId = () => {
  if (window.location.pathname.includes('/app/accounts')) {
    return window.location.pathname.split('/')[3];
  }
  return '';
};

const contactUrl = contactId =>
  `/api/v1/accounts/${accountId()}/contacts/${contactId}/team_number`;

const adminUrl = () => `/api/v1/accounts/${accountId()}/aceleres/team_numbers`;

export default {
  state(contactId) {
    return axios.get(contactUrl(contactId));
  },
  mark(contactId) {
    return axios.post(contactUrl(contactId));
  },
  unmark(contactId) {
    return axios.delete(contactUrl(contactId));
  },
  // Solta a trava manual: o contato volta a seguir o cadastro do Aceleres.
  followAuto(contactId) {
    return axios.delete(`${contactUrl(contactId)}/manual_override`);
  },
  history(contactId, params = {}) {
    return axios.get(`${contactUrl(contactId)}/history`, { params });
  },
  list(params = {}) {
    return axios.get(adminUrl(), { params });
  },
};
